const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT}/api/v1`;
const PROFILE_GATEPASS_TYPE_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/profile/gatepass/type";


export default {

    LIST_PROFILE_GATEPASS_CONFIGURATION:                                   PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/list",
    ADD_PROFILE_GATEPASS_CONFIGURATION:                                    PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/create",
    VIEW_PROFILE_GATEPASS_CONFIGURATION:                                   PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/view",
    UPDATE_STATUS_PROFILE_GATEPASS_CONFIGURATION:                          PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/update/status",
    DELETE_PROFILE_GATEPASS_CONFIGURATION:                                 PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/delete",
    UPDATE_DETAILS_PROFILE_GATEPASS_CONFIGURATION:                         PROFILE_GATEPASS_TYPE_API_ENDPOINT + "/update",
}